// extracted by mini-css-extract-plugin
export default {"loadingAnimation":"Loader_loadingAnimation__2Sj57","normal":"Loader_normal__rF3YT","loading-animation":"Loader_loading-animation__QDGeT","small":"Loader_small__VlWD1"};